/* Office Walker 2A - product gallery thumbnail swap + finish selector + sticky buy bar.

   2026-09-07. The finish selector was added because the three finishes are
   separately selectable when backing on Kickstarter, so the choice is real.
   Two things hang off it: the gallery swaps to that finish's photographs, and
   every Kickstarter link on the page gets a utm_content carrying the finish, so
   a click made from the Natural wood selection is distinguishable from one made
   from Black wood in the campaign report.

   utm_content is written with URLSearchParams.set, which replaces that one
   parameter and leaves everything else on the query string alone. The ref
   parameter on the campaign URL survives untouched, which is the point: it is
   what Kickstarter attributes the referral with.

   The slug comes from data-utm in the Liquid and is English on every locale, on
   purpose. Sending the translated finish name would split one finish into four
   rows in the report.

   The waitlist CTA is not touched here. Nothing below reads or writes it. */
(function () {
  'use strict';

  function swapMain(main, src, alt) {
    if (!main || !src) return;
    main.src = src;
    if (alt) main.alt = alt;
  }

  function markThumbs(strip, active) {
    strip.querySelectorAll('.ow2-pdp__thumb').forEach(function (t) {
      t.classList.toggle('is-on', t === active);
    });
  }

  document.querySelectorAll('[data-ow2-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-pdp-main]');
    if (!main) return;
    g.querySelectorAll('.ow2-pdp__thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        swapMain(main, t.getAttribute('data-thumb'), t.getAttribute('data-alt'));
        var strip = t.closest('[data-finish-strip]') || g;
        markThumbs(strip, t);
      });
    });
  });

  /* Kickstarter links live in other sections (the proof bar and the footer), so
     this reaches across the page rather than staying inside the product
     section. It only runs on a page that actually has a finish selector. */
  function tagCampaignLinks(slug) {
    if (!slug) return;
    document.querySelectorAll('a[href*="kickstarter.com"]').forEach(function (a) {
      try {
        var u = new URL(a.href, window.location.origin);
        u.searchParams.set('utm_content', slug);
        a.href = u.toString();
      } catch (e) {
        /* A malformed href is left exactly as it was found. */
      }
    });
  }

  document.querySelectorAll('[data-ow2-finishes]').forEach(function (wrap) {
    var buttons = wrap.querySelectorAll('.ow2-pdp__finish');
    if (!buttons.length) return;
    var gallery = document.querySelector('[data-ow2-gallery]');
    var main = gallery ? gallery.querySelector('[data-pdp-main]') : null;

    function select(btn) {
      var key = btn.getAttribute('data-finish');
      buttons.forEach(function (b) {
        b.setAttribute('aria-pressed', String(b === btn));
      });
      if (gallery) {
        var strips = gallery.querySelectorAll('[data-finish-strip]');
        var chosen = null;
        strips.forEach(function (strip) {
          var on = strip.getAttribute('data-finish-strip') === key;
          strip.classList.toggle('is-off', !on);
          if (on) chosen = strip;
        });
        if (chosen) {
          var first = chosen.querySelector('.ow2-pdp__thumb');
          if (first) {
            swapMain(main, first.getAttribute('data-thumb'), first.getAttribute('data-alt'));
            markThumbs(chosen, first);
          }
        }
      }
      tagCampaignLinks(btn.getAttribute('data-utm'));
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () { select(b); });
    });

    /* Tag the links for whichever finish is already selected on load, so a
       visitor who never touches the selector is still attributed. */
    var current = wrap.querySelector('.ow2-pdp__finish[aria-pressed="true"]') || buttons[0];
    if (current) tagCampaignLinks(current.getAttribute('data-utm'));
  });

  // Sticky buy bar appears once the hero reserve form scrolls out of view.
  var bar = document.querySelector('[data-ow2-buybar]');
  var anchor = document.querySelector('[data-pdp-reserve]');
  if (bar && anchor && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-shown', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -40px 0px' });
    io.observe(anchor);
  }
})();